var _desc, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCustomers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Information-Desk-Customer--Streamline-Ultimate",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Information Desk Customer Streamline Icon: https://streamlinehq.com\n  ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M3 3.75c0 0.79565 0.31607 1.55871 0.87868 2.12132C4.44129 6.43393 5.20435 6.75 6 6.75s1.55871 -0.31607 2.12132 -0.87868C8.68393 5.30871 9 4.54565 9 3.75s-0.31607 -1.55871 -0.87868 -2.12132C7.55871 1.06607 6.79565 0.75 6 0.75s-1.55871 0.31607 -2.12132 0.87868C3.31607 2.19129 3 2.95435 3 3.75Z",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.25 13.5c0 -1.3924 -0.5531 -2.7277 -1.53769 -3.71231C8.72774 8.80312 7.39239 8.25 6 8.25c-1.39239 0 -2.72774 0.55312 -3.71231 1.53769C1.30312 10.7723 0.75 12.1076 0.75 13.5v2.25H3l0.75 7.5h4.5l0.75 -7.5h2.25V13.5Z",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.125 3.375c0 0.69619 0.2766 1.36387 0.7688 1.85616C17.3861 5.72344 18.0538 6 18.75 6c0.6962 0 1.3639 -0.27656 1.8562 -0.76884 0.4922 -0.49229 0.7688 -1.15997 0.7688 -1.85616 0 -0.69619 -0.2766 -1.36387 -0.7688 -1.85616C20.1139 1.02656 19.4462 0.75 18.75 0.75c-0.6962 0 -1.3639 0.27656 -1.8562 0.76884 -0.4922 0.49229 -0.7688 1.15997 -0.7688 1.85616Z",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M14.25 11.25c0 -1.1935 0.4741 -2.33807 1.318 -3.18198C16.4119 7.22411 17.5565 6.75 18.75 6.75s2.3381 0.47411 3.182 1.31802c0.8439 0.84391 1.318 1.98848 1.318 3.18198h-9Z",
    strokeWidth: 1.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    stroke: "#6571fe",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10.738 11.25H23.25",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCustomers);
export default __webpack_public_path__ + "static/media/icon-customers.0b9375898c742ac0cf98a0de0888bdae.svg";
export { ForwardRef as ReactComponent };